import { get } from "lodash";
import History from "../../../../history";
import { getGraphError } from "../errorHandler";
export default (function (err) {
    return new Promise(function (resolve, reject) {
        History.push({
            pathname: "/welcome/logout",
            state: {
                nextPathname: location.pathname
            }
        });
        /**
          No resolve/reject as we want this promise to hang.
          No chained code should execeute (neither success or error handles)
          @author: Richard Scoones
        */
        /**
         * However.... apollo caches requests too, if we just hang it will not make
         * another request for ever.... this is bad.
         * @author: Richard Scoones
         */
        var isApolloQuery = get(err, "config.isApolloQuery", false);
        if (isApolloQuery) {
            reject(getGraphError(err));
        }
    });
});
